/** Rendu seulement si {@link ../utils/isAppDebug} (voir ConfigContext). */
import React, { useState } from "react";
import { createPortal } from "react-dom";
import {
  DEBUG_CONFIG_SUBDOMAIN_STORAGE_KEY,
  useConfigDebug,
} from "../config/ConfigContext";

export default function DebugConfigPanel() {
  const { reloadConfig, configRefreshing } = useConfigDebug();
  const [subdomainInput, setSubdomainInput] = useState(() => {
    if (typeof sessionStorage === "undefined") return "";
    return sessionStorage.getItem(DEBUG_CONFIG_SUBDOMAIN_STORAGE_KEY) || "";
  });
  const [localError, setLocalError] = useState(null);

  const onApply = async (e) => {
    e.preventDefault();
    setLocalError(null);
    try {
      await reloadConfig(subdomainInput);
    } catch (err) {
      setLocalError(err?.message || "Échec du chargement");
    }
  };

  const onReset = async (e) => {
    e.preventDefault();
    setSubdomainInput("");
    setLocalError(null);
    try {
      await reloadConfig("");
    } catch (err) {
      setLocalError(err?.message || "Échec du chargement");
    }
  };

  const panel = (
    <div
      className="pointer-events-auto fixed bottom-4 right-4 w-[min(100vw-2rem,18rem)] rounded-lg border border-amber-600/40 bg-neutral-900/95 p-3 text-xs text-neutral-100 shadow-xl backdrop-blur-sm"
      style={{ zIndex: 2147483647 }}
      role="region"
      aria-label="Debug config partenaire"
    >
      <div className="mb-2 font-semibold uppercase tracking-wide text-amber-400/90">
        Debug config (n8n)
      </div>
      <form onSubmit={onApply} className="flex flex-col gap-2">
        <label className="flex flex-col gap-1">
          <span className="text-neutral-400">Sous-domaine</span>
          <input
            type="text"
            value={subdomainInput}
            onChange={(e) => setSubdomainInput(e.target.value)}
            placeholder="ex. partner"
            className="rounded border border-neutral-600 bg-neutral-800 px-2 py-1.5 text-neutral-100 placeholder:text-neutral-500 focus:border-amber-500 focus:outline-none"
            autoComplete="off"
            disabled={configRefreshing}
          />
        </label>
        <div className="flex flex-wrap gap-2">
          <button
            type="submit"
            disabled={configRefreshing}
            className="rounded bg-amber-600 px-3 py-1.5 font-medium text-neutral-950 hover:bg-amber-500 disabled:opacity-50"
          >
            {configRefreshing ? "…" : "Appliquer"}
          </button>
          <button
            type="button"
            onClick={onReset}
            disabled={configRefreshing}
            className="rounded border border-neutral-500 px-3 py-1.5 text-neutral-200 hover:bg-neutral-800 disabled:opacity-50"
          >
            Reset
          </button>
        </div>
      </form>
      {localError ? (
        <p className="mt-2 text-red-400">{localError}</p>
      ) : null}
    </div>
  );

  if (typeof document === "undefined") {
    return null;
  }
  return createPortal(panel, document.body);
}
